import { styled, Typography, TypographyProps } from '@mui/material';

export const Digit = styled((props: TypographyProps) => (
  <Typography
    variant="paragraphRegular"
    fontSize="inherit"
    px={1}
    py={0.5}
    width={48}
    textAlign="center"
    {...props}
  />
))(({ theme }) => ({}));
